import React, { useState, useEffect } from 'react';
import {
  Tabs,
  Tab,
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Chip,
  Card,
  Grid,
  TextField,
  useMediaQuery,
  CardContent,
  IconButton,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { useNavigate } from 'react-router-dom';
import { Search } from '@mui/icons-material';
import dayjs from 'dayjs';
import { getAllRewardsAction } from '../APIs/action';
import { toast, ToastContainer } from 'react-toastify';
import GiftTabs from './GiftTab';
import { GiftStatusEnum, REWARD_TABS } from '../utils';
import { useDispatch, useSelector } from 'react-redux';

const RewardsTabs = ({ allowedTabs = [] }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery('(max-width: 768px)');

  const selectedTabReward = useSelector((state) => state.rewardsReducer.selectedTabReward);
  const [selectedTab, setSelectedTab] = useState(
      selectedTabReward && allowedTabs.includes(selectedTabReward) ? selectedTabReward : allowedTabs[0]
  );
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rewardData, setrewardData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (allowedTabs.length > 0) {
        const newTab = selectedTab === REWARD_TABS['NETWORK_INFLUENCER'] ? 'NETWORK INFLUENCER' : selectedTab;
        dispatch({
            type: 'SET_SELECTED_TAB_REWARD',
            payload: allowedTabs.includes(newTab) ? newTab : allowedTabs[0],
        });
    }
  }, [selectedTab, allowedTabs]);

  const fetchData = async () => {
    const payload = {
      start_date: startDate.format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD'),
      type: selectedTab === REWARD_TABS['NETWORK_INFLUENCER'] ? 'NETWORK_INFLUENCER' : selectedTab,
    };
    setLoading(true);
    const { data, message, error } = await getAllRewardsAction(payload);
    setLoading(false);
    if (!error) {
      setrewardData(data);
    } else {
      toast.error(message);
    }
  };

  useEffect(() => {
    if (startDate && endDate && selectedTab) {
      fetchData();
    }
  }, [selectedTab, startDate, endDate]);
  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  const handleShowDetails = (gift_id) => {
    navigate('/benefits/reward-detail', {
      state: {
        gift_id: gift_id,
        type: selectedTab === REWARD_TABS['NETWORK_INFLUENCER'] ? 'NETWORK_INFLUENCER' : selectedTab,
      },
    });
  };
  const [searchQuery, setSearchQuery] = useState('');
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  useEffect(() => {
    const oneMonthAgo = dayjs().subtract(1, 'month');
    setStartDate(oneMonthAgo);
    setEndDate(dayjs());
  }, []);
  const { network_gifts_data, gifts_summary_data, gift_list } = rewardData;
  const allGifts = gift_list ? gift_list.flatMap((item) => item.data) : [];
  const filteredData = allGifts.filter((gift) => {
    return (
      (selectedStatus === 0 || gift.status === selectedStatus) &&
      (gift.beneficiary_name
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
        gift.beneficiary_phone.includes(searchQuery))
    );
  });
  useEffect(() => {
    if(gift_list){
      setSelectedStatus(gift_list[0]?.id)
    }
  },[gift_list])

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <ToastContainer />
      <Box sx={{ mb: 3, overflowX: 'auto' }}>
        <Tabs
          value={selectedTab}
          onChange={handleChange}
          sx={{ flexWrap: 'wrap' }}
        >
          {allowedTabs.length > 0 ? (
            allowedTabs.map((tab) => (
              <Tab
                key={tab}
                label={REWARD_TABS[tab] || tab}
                value={tab}
                sx={{ fontWeight: 'bold', fontSize: '1rem' }}
              />
            ))
          ) : (
            <p>No tabs available</p>
          )}
        </Tabs>
      </Box>

      {/* Date Picker */}
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          lg={12}
        >
          <Card
            sx={{
              borderRadius: '12px',
              boxShadow:
                '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
              mb: 1,
              p: 2,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              sx={{
                color: '#636363',
                fontWeight: 'bold',
              }}
            >
              Select Date
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <DatePicker
                label='Start Date'
                value={startDate}
                onChange={(newValue) => setStartDate(newValue)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '15px !important',
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size='small'
                  />
                )}
              />
              <DatePicker
                label='End Date'
                value={endDate}
                onChange={(newValue) => setEndDate(newValue)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '15px !important',
                  },
                }}
                maxDate={dayjs()}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size='small'
                  />
                )}
              />
            </Box>
          </Card>
        </Grid>
        <Grid
          item
          xs={12}
          lg={12}
        >
          <Card
            sx={{
              borderRadius: '12px',
              boxShadow:
                '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
              marginBottom: '20px',
            }}
          >
            <Box sx={{ p: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography
                  variant='h6'
                  sx={{ pb: 2, fontWeight: 'bold' }}
                >
                  Rewards
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  borderBottom: gifts_summary_data?  '2px solid #A3A3A380': 'none',
                  paddingBottom: 3,
                  marginBottom: 3,
                }}
              >
                {network_gifts_data && network_gifts_data.map((item, index) => (
                  <Box
                    key={item.display_name}
                    sx={{
                      borderRight:
                        index !== network_gifts_data.length - 1
                          ? '2px solid #A3A3A380'
                          : 'none',
                      paddingX: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      width: '50%',
                      textAlign: 'center',
                    }}
                  >
                    <Typography
                      variant='subtitle1'
                      sx={{
                        fontSize: '14px',
                        color: '#9B9B9B',
                        fontWeight: 'bold',
                      }}
                    >
                      {item.display_name } 
                    </Typography>
                    <Typography
                      variant='subtitle2'
                      sx={{
                        color: item.color,
                        fontSize: { xs: '1rem', md: '1.5rem' },
                        fontWeight: 'bold',
                      }}
                    >
                      {item.value !== undefined && item.value !== null ? item.value : '-'}
                    </Typography>
                  </Box>
                ))}
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                {gifts_summary_data && gifts_summary_data.map((item, index) => (
                  <Box
                    key={item.display_name}
                    sx={{
                      borderRight:
                        index !== gifts_summary_data.length - 1
                          ? '2px solid #A3A3A380'
                          : 'none',
                      paddingX: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      width: '50%',
                      textAlign: 'center',
                    }}
                  >
                    <Typography
                      variant='subtitle1'
                      sx={{
                        fontSize: '14px',
                        color: '#9B9B9B',
                        fontWeight: 'bold',
                      }}
                    >
                      {item.display_name}
                    </Typography>
                    <Typography
                      variant='subtitle2'
                      sx={{
                        color: item.color,
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                      }}
                    >
                      {item.value !== undefined && item.value !== null ? item.value : '-'}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Card>
        </Grid>
      </Grid>

      {gift_list && (
        <GiftTabs
          giftListData={gift_list}
          selectedStatus={selectedStatus}
          setSelectedStatus={setSelectedStatus}
        />
      )}

      {selectedTab !== REWARD_TABS['SELF'] && (
        <Grid
          container
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Grid
            item
            xs={12}
            lg={12}
          >
            <Card
              sx={{
                borderRadius: '12px',
                boxShadow:
                  '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                padding: '20px',
              }}
            >
              <Typography
                sx={{ color: '#636363', fontWeight: 'bold', pb: 1 }}
              >
                Search By
              </Typography>
              <TextField
                label='Beneficiary Name / Phone'
                variant='outlined'
                value={searchQuery}
                fullWidth
                onChange={handleSearchChange}
                InputProps={{
                  endAdornment: (
                    <IconButton>
                      {' '}
                      <Search />
                    </IconButton>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '15px',
                  },
                }}
              />
            </Card>
          </Grid>
        </Grid>
      )}


      {/* Table */}
      {!isMobile ? (
        <TableContainer
          component={Paper}
          sx={{ overflowX: 'auto' }}
        >
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  background: '#f4f6f8',
                  borderBottom: '1px dashed #919eab33',
                }}
              >
                <TableCell
                  sx={{
                    color: '#637381',
                    fontWeight: 'bold',
                    borderBottom: 'none',
                  }}
                >
                  Beneficiary Name
                </TableCell>
                <TableCell
                  sx={{
                    color: '#637381',
                    fontWeight: 'bold',
                    borderBottom: 'none',
                  }}
                >
                  Phone
                </TableCell>
                <TableCell
                  sx={{
                    color: '#637381',
                    fontWeight: 'bold',
                    borderBottom: 'none',
                  }}
                >
                  Role
                </TableCell>
                <TableCell
                  sx={{
                    color: '#637381',
                    fontWeight: 'bold',
                    borderBottom: 'none',
                  }}
                >
                  Gift Name
                </TableCell>
                {selectedStatus !== GiftStatusEnum['ANNOUNCED'].status && (
                  <TableCell
                    sx={{
                      color: '#637381',
                      fontWeight: 'bold',
                      borderBottom: 'none',
                    }}
                  >
                    Announced Date
                  </TableCell>
                )}
                <TableCell
                  sx={{
                    color: '#637381',
                    fontWeight: 'bold',
                    borderBottom: 'none',
                  }}
                >
                  Status
                </TableCell>
                
                  <TableCell
                    sx={{
                      color: '#637381',
                      fontWeight: 'bold',
                      borderBottom: 'none',
                    }}
                  >
                    Status Change Date
                  </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData && filteredData.length > 0 ? (
                filteredData.map((gift, index) => {
                  const statusData = Object.values(GiftStatusEnum).find(
                    (s) => s.status === gift.status,
                  );
                  return (
                    <TableRow
                      key={index}
                      sx={{
                        borderBottom: '1px dashed #919eab33',
                        cursor: 'pointer',
                      }}
                      onClick={() => handleShowDetails(gift.id)}
                    >
                      <TableCell sx={{ borderBottom: 'none' }}>
                        {gift.beneficiary_name}
                      </TableCell>
                      <TableCell sx={{ borderBottom: 'none' }}>
                        {gift.beneficiary_phone}
                      </TableCell>
                      <TableCell sx={{ borderBottom: 'none' }}>
                        {gift.beneficiary_role}
                      </TableCell>
                      <TableCell sx={{ borderBottom: 'none' }}>
                        {gift.gift_product_name}
                      </TableCell>
                      {selectedStatus !== GiftStatusEnum['ANNOUNCED'].status && (
                        <TableCell sx={{ borderBottom: 'none' }}>
                          {gift.announced_date || '-'}
                        </TableCell>
                      )}
                      <TableCell sx={{ borderBottom: 'none' }}>
                        <Chip
                          label={statusData?.label}
                          sx={{
                            backgroundColor: statusData?.color,
                            color: 'white',
                            fontWeight: 'bold',
                          }}
                        />
                      </TableCell>
                      
                        <TableCell sx={{ borderBottom: 'none' }}>
                          {gift.status_change_date || '-'}
                        </TableCell>
                      
                    </TableRow>
                  );
                })
              ) : (
                <TableRow sx={{ borderBottom: '1px dashed #919eab33' }}>
                  <TableCell
                    colSpan={6}
                    align='center'
                  >
                    No data available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Box>
          {filteredData.length > 0 ? (
            filteredData.map((gift, index) => {
              const statusData = Object.values(GiftStatusEnum).find(
                (s) => s.status === gift.status,
              );
              return (
                <Card
                  key={index}
                  sx={{
                    cursor: 'pointer',
                    mb: 2,
                    borderRadius: '12px',
                    boxShadow:
                      '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                  }}
                  onClick={() => handleShowDetails(gift.id)}
                >
                  <CardContent
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Box sx={{ pr: 1 }}>
                      <Typography
                        variant='body1'
                        sx={{ fontWeight: 'bold' }}
                      >
                        Beneficiary: {gift.beneficiary_name}
                      </Typography>
                      <Typography
                        variant='body2'
                        sx={{}}
                      >
                        Gift Name: {gift.gift_product_name}
                      </Typography>
                      <Typography variant='body2'>
                        Phone: {gift.beneficiary_phone}
                      </Typography>
                      <Typography variant='body2'>
                        Role: {gift.beneficiary_role}
                      </Typography>
                      {selectedStatus !== GiftStatusEnum['ANNOUNCED'].status && (
                        <Typography variant='body2'>
                          Announced Date: {gift.announced_date}
                        </Typography>
                      )}
                    </Box>
                    <Box>
                      <Chip
                        label={statusData?.label}
                        sx={{
                          backgroundColor: statusData?.color,
                          color: 'white',
                          fontWeight: 'bold',
                          my: 1,
                        }}
                      />
                      <Typography variant='body2'>
                        {gift.status_change_date}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              );
            })
          ) : (
            <Typography align='center'>No data available</Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default RewardsTabs;
